import React, { FunctionComponent } from 'react';
import { FormItem } from '@erecruit/ui-kit';
import { Intl } from '@erecruit/core';
import { getFieldSlug } from '../../helpers';
import { PositionField } from '../../types';
import AsyncSelect from './AsyncSelect';

const { FormattedMessage } = Intl;

export interface FormFieldProps {
  field: PositionField;
  messageFormatId: string;
}

interface SelectFieldProps extends FormFieldProps {
  multi?: boolean;
}

const generateFieldRules = (field: PositionField) => {
  const rules = [];

  if (field.settings && field.settings.required) {
    rules.push({
      required: true,
      message: (
        <FormattedMessage id={messageIds.vms.errors.form.requiredField} />
      ),
    });
  }

  return rules;
};

const FormFieldItem: FunctionComponent<FormFieldProps> = ({
  field,
  children,
  messageFormatId,
}) => {
  const rules = generateFieldRules(field);
  const label = getFieldSlug(field);
  const messageId = `${messageFormatId}.${field.section}.${label}`;

  const initialValue = field.value?.id || field.value;

  return (
    <FormItem
      id={label}
      key={label}
      label={<FormattedMessage id={Intl.strToLocalizationKeys(messageId)} />}
      hasFeedback
      options={{
        rules: rules,
        initialValue,
      }}
    >
      {children}
    </FormItem>
  );
};

interface OptionProps {
  id: string;
  name: string;
}

const SelectField = ({ field, multi, messageFormatId }: SelectFieldProps) => {
  const mode = multi ? 'multiple' : 'default';

  return (
    <FormFieldItem field={field} messageFormatId={messageFormatId}>
      <AsyncSelect field={field} mode={mode} />
    </FormFieldItem>
  );
};

export { SelectField, FormFieldItem };
